import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Tiny helper that watches for `?action=<value>` in the URL and runs the
 * matching callback once. Removes the param afterwards so refreshes don't
 * re-trigger the action (e.g. re-opening the modal).
 *
 * @param {Object<string, () => void>} handlers map of action → callback
 */
export default function useFabAction(handlers) {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const action = searchParams.get('action');
    if (!action) return;
    const fn = handlers && handlers[action];
    if (!fn) return;
    // Defer to next tick so the page has time to render its dialogs etc.
    const t = setTimeout(() => {
      try { fn(); } catch (e) { /* swallow — UX only */ }
      // Strip the param without adding a history entry
      const next = new URLSearchParams(searchParams);
      next.delete('action');
      setSearchParams(next, { replace: true });
    }, 50);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);
}
